export default __webpack_public_path__ + "static/news29-5e2c7ff09dc955a2118fc5f24cca68e0.jpg";